import httpHelper from "@/helpers/httpHelper";

/**
 * @module refundManualCharge
 */

// action types 
/**
 * Constant for the REFUND_MANUAL_CHARGE action type
 * @type {string}
 */
export const REFUND_MANUAL_CHARGE = "refundManualCharge";

/**
 * @exports refundManualCharge
 * @type {object}
 */
export default {
    
    actions: {
        /**
         * Refund a Manual Charge
         * @function REFUND_MANUAL_CHARGE
         * @async
         * @param {object} context - The store object 
         * @param {object} payload - The data need to be send to the server 
         * @return {Promise<object>} - A promise that resolves to the server response or rejected with an error
         */
        [REFUND_MANUAL_CHARGE](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .postData('refund/custom-charge',payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
};
